/* eslint-disable max-statements */
/* eslint-disable complexity */
/* eslint-disable consistent-return */

// Converted Common class to a functional utility module

// No need for React import since this is now a utility function

export const formatDate = (date, inputFormat, outputFormat) => {
  try {
    if (date !== '' && inputFormat !== '' && outputFormat !== '') {
      let inputFormatArr = [];
      let outputFormatArr = [];
      let inputDateArr = [];
      let dateArr = {};
      let outputDateArr = [];
      let dateSplitWith = '';
      let inputFormatSplitWith = '';
      let outFormatSplitWith = '';

      if (inputFormat.indexOf('-') > -1) {
        inputFormatSplitWith = '-';
      } else {
        inputFormatSplitWith = '/';
      }
      if (outputFormat.indexOf('-') > -1) {
        outFormatSplitWith = '-';
      } else {
        outFormatSplitWith = '/';
      }
      if (date.indexOf('-') > -1) {
        dateSplitWith = '-';
      } else {
        dateSplitWith = '/';
      }

      inputFormatArr = inputFormat.split(inputFormatSplitWith);
      inputDateArr = date.split(dateSplitWith);
      outputFormatArr = outputFormat.split(outFormatSplitWith);

      for (let index in inputFormatArr) {
        if (inputFormatArr[index].toLowerCase().indexOf('yyyy') === 0) {
          dateArr['yyyy'] = inputDateArr[index];
        } else if (inputFormatArr[index].toLowerCase().indexOf('mm') === 0) {
          dateArr['mm'] = inputDateArr[index];
          if (inputFormatArr[index].length === 2 && dateArr['mm'].toString().length === 1) {
            dateArr['mm'] = '0' + dateArr['mm'].toString();
          }
        } else {
          dateArr['dd'] = inputDateArr[index];
          if (inputFormatArr[index].length === 2 && dateArr['dd'].toString().length === 1) {
            dateArr['dd'] = '0' + dateArr['dd'].toString();
          }
        }
      }

      for (let index in outputFormatArr) {
        if (outputFormatArr[index].toLowerCase().indexOf('yyyy') === 0) {
          outputDateArr[index] = dateArr['yyyy'];
        } else if (outputFormatArr[index].toLowerCase().indexOf('mm') === 0) {
          outputDateArr[index] = dateArr['mm'];
        } else {
          outputDateArr[index] = dateArr['dd'];
        }
      }

      return outputDateArr.join(outFormatSplitWith);
    } else {
      return date;
    }
  } catch (e) {
    // Optionally log error
  }
};

